var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"control control-button horizontal-menu-arrow-right",attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('icon-menu-arrow-right')],1)}
var staticRenderFns = []

export { render, staticRenderFns }